import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22 15H2L5.18182 14.0435L7.90909 10.2174L11.0909 11.6522L14.7273 7.34783L18.3636 10.2174L22 4V15Z",
		fill: "#C7CEFE"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3 14.3304L5.77591 13.9263L8.91182 9.8673L11.895 11.7722L15.3814 6.84422L18.4655 9.86683L22.0909 4",
		stroke: "#5946E5",
		strokeWidth: 1.2,
		strokeLinecap: "square"
	})]
});
export default SvgArea;
